import { errorNotifier } from "../components/NotificationHandler";
import http, { AUTH_ROUTES } from "../services/api";
import { PRIMARY_HEX } from "../theme/primary";

export const getUserProfile = async (userId, setUserProfile, setLoading) => {
  const session = localStorage.getItem("WMS#221#");
  try {
    const data = await http.get(AUTH_ROUTES.GET_USER(userId));
    // console.log("data", data);
    const profile = data?.data?.userDetails?.data?.users?.[0];
    let estates = [];
    try {
      const response = await http.get(AUTH_ROUTES.GET_ESTATES);
      estates = Array.isArray(response?.data?.data) ? response.data.data : [];
    } catch (_) {
      // Never use raw profile payment configuration as readiness fallback.
      estates = (profile?.estates || []).map((membership) => ({
        ...membership,
        estateId: typeof membership.estateId === "object"
          ? { ...membership.estateId, paymentSettings: {} }
          : membership.estateId,
      }));
    }
    // A logout while either request was in flight must not restore old data.
    if (!session || session !== localStorage.getItem("WMS#221#")) return;
    setUserProfile({ ...profile, estates });
    setLoading(false);
    // console.log("userrrrr", data?.data?.userDetails?.data?.users?.[0]?.streetId?.estateId?.colorSetting);
    localStorage.setItem("brandColor", PRIMARY_HEX);
    return data;
  } catch (e) {
    setLoading(false);
    console.log("errror", e.response);
    errorNotifier(e.response?.data?.result?.message);
  }
};
